export const wrapErrorByMessage = (error: Error, message: string) => {
    const errorMessage = error instanceof Error ? error.message : String(error);
    const wrappedError = new Error(`[${message}] ${errorMessage}`);
    // 保留原始错误堆栈，拼接到 wrappedError 中（可选）
    if (error instanceof Error && error.stack) {
        wrappedError.stack += '\nCaused by: ' + error.stack;
    }
    return wrappedError;
};
